export default {
  presenter: 'hroncok',
  title: 'Hra v Pythonu pro naprosté začátečníky i pokročilé',
  subtitle: 'začátečníci',
  text: `
Na tomto workshopu pod vedením lektora vytvoříte variantu arkádové hry Asteroids, která poprvé
vyšla na konci sedmdesátých let. Využijeme k tomu framework Pyglet, o kterém nejsou potřeba
žádné předchozí znalosti.  
Hráč bude ovládat raketku létající vesmírem a střílející na kolem poletující asteroidy. Ale
pozor, s asteroidem se samozřejmě můžete i srazit.  
Předpokládá se pouze velmi základní znalost syntaxe Pythonu a základy objektového programování
(klidně z jiného jazyka). Základní znalosti z matematiky a fyziky jsou výhodou (setrvačnost,
zrychlení, sinus, cosinus...) ale ne nutností, ale nic hardcore nečekejte, předpokládejme
vákuum s nulovým třením.  
Vše ostatní se naučíte na workshopu. Pokročilejší Pythonisti mohou rozvíjet hru různými dalšími
směry, takže by se neměli nudit (výbuchy, efekty, životy, štíty...).
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/hroncok-hra-python.js